/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import "moment-timezone";
import Moment from "react-moment";
import { DDD_DD_MMM_YYYY_HH_MM_SS_A, TIME_ZONE } from "../../../../utils/const";
export const DateTimeColumnFormatter = (cellContent, row, rowIndex) => {
  const { createdAt = "" } = row || {};
  return (
    <>
      <span className="text-dark-75 d-block">
        <Moment date={createdAt} format={DDD_DD_MMM_YYYY_HH_MM_SS_A} tz={TIME_ZONE} />
        {createdAt.length === 0 && "-"}
      </span>
    </>
  );
};
